import React from 'react'
import logo from '../../images/image (23).png'
import logo2 from '../../images/image (24).png'
import personimg from '../../images/image (25).png'
import personimg2 from '../../images/image (26).png'
import personimg3 from '../../images/image (27).png'
import personimg4 from '../../images/image (28).png'
import send from '../../images/Vector.png'
import rightlogo from '../../images/image (30).png';
import personimg78 from '../../images/image (31).png'
const GroupChart = () => {
    return (
        <>
            <div className='groupchart_wrapper'>
                <div className='left_groupchart'>
                    <div className='groupchart_input_wrapper'>
                        <input type='text' placeholder='Search' />
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </div>
                    <div style={{
                        padding: '0px 20px'
                    }}>
                        <div className='all_groupchat_wrapper'>
                            <p>All</p>
                            <p>Fisibility</p>
                            <p>Groups</p>
                        </div>
                    </div>

                    <div className='fisibility_groups_Wrapper'>
                        {[1, 2, 3, 5, 4, , 4, 7, 8, 8].map((e, i) => {
                            return (
                                <>
                                    <div className='fisibilty_group_div'>
                                        <div className='fisibilty_group_logo_div'>
                                            <img src={logo} />
                                        </div>
                                        <div className='fisibilty_heading_div'>
                                            <h6>Fisibility Group</h6>
                                            <p>Last 2d ago   <span>10 Members</span></p>
                                        </div>
                                    </div>
                                </>
                            )
                        })}

                    </div>
                </div>
                <div className='center_groupchart'>

                    <div className='center_fisibilty_group_wrapper'>
                        <div className='center_fisibilty_group_logo_div'>
                            <img src={logo2} />
                        </div>
                        <p style={{
                            marginBottom: '0px',
                            fontWeight: '500',
                            fontSize: '17px'
                        }}>Fisibility Group</p>
                    </div>

                    <div className='fisibilty_chat_wrapper'>
                        {[personimg, personimg2, personimg3].map((e, i) => {
                            return (
                                <>
                                    <div className='message_wrapper'>
                                        <div className='message_img_div'>
                                            <img src={e} />
                                        </div>
                                        <div className='message_time_wrapper_div'>
                                            <div className='message_div'>Hi</div>
                                            <p>14 May 2:05pm</p>
                                        </div>
                                    </div>
                                </>
                            )
                        })}
                        <div className='reply_wrapper'>
                            <div className='message_time_wrapper_div'>
                                <div className='reply_div'>Hi</div>
                                <p>14 May 2:05pm</p>
                            </div>
                            <div className='message_img_div'>
                                <img src={personimg4} />
                            </div>

                        </div>

                        <div className='message_wrapper'>
                            <div className='message_img_div'>
                                <img src={personimg} />
                            </div>
                            <div className='message_time_wrapper_div'>
                                <div className='message_div'>Hi</div>
                                <p>14 May 2:05pm</p>
                            </div>
                        </div>
                    </div>

                    <div className='message_input_wrapper'>
                        <input defaultValue={'Hi'} />
                        <img src={send} style={{
                            width: '25px',
                            cursor: 'pointer'
                        }} />
                    </div>
                </div>
                <div className='right_groupchart'>
                    <h1>Fisibility Group</h1>
                    <div className='right_group_logo'>
                        <img src={rightlogo} />
                    </div>
                    <div className='member_since_div'>Member Since May 2025</div>
                    <div className='members_Wrapper'>
                        <p>Members</p>
                        <span>View All</span>
                    </div>
                    <div className='members_names_wrapper'>
                        {[1, 2, 3, 4, 5, 6, 58, 4, 5, 8, 5, 6, 9,].map((e, i) => {
                            return (
                                <>
                                    <div className='member'>
                                        <div className='member_img'>
                                            <img src={personimg78} />
                                        </div>
                                        <p>Lorem Ipsum</p>
                                    </div>
                                </>
                            )
                        })}

                    </div>
                </div>
            </div>
        </>
    )
}

export default GroupChart
